# Phone Number View
# =================
Backbone = require 'backbone'
Backbone.$ = $
SharedPhoneNumberTemplate = require('../../../../phone_number.html.mustache')

class SharedFooterUSPhoneNumberView extends Backbone.View
  class: 'support'

  initialize: (options = {})->
    @I18nScope = 'modules.support'
    @template = SharedPhoneNumberTemplate
    @popupContainer = $("#popup")

  render: ->
    GIG.Modal.open
      el: @popupContainer
      closeOnBgClick: true
      closeOnEscKey: true
    @$el.append toHtml( @template, @toHash(), @I18nScope )
    @popupContainer.html(@el)

  toHash: ->
    deal = Groupon.Support?.currentOrder?.DEAL_TYPE || null
    hash =
      showMRDealPhoneNumbers: (deal is "GETAWAYS_MARKET_RATE")
    if deal is "GETAWAYS_MARKET_RATE"
      TrackingHub.add("SUPPORT-APP-MARKET-RATE-CALL-US", {data: window.currentUser})
    return hash

  closeModal: ->
    GIG.Modal.close()
    return false

  events:
    'click .close-modal' : "closeModal"
    'click .b-close' : "closeModal"

module.exports = SharedFooterUSPhoneNumberView
